<template>
  <div id="root" class="video-page">
    <div id="app" class="logged-in">
      <div id="app-menu" :class="isModalKharid || isModalVersion ? 'custom' : ''">
        <div id="app-menu-content-wrapper">

          <!-- =========================
               CREATE VIEW (prompt + settings)
               ========================= -->
          <div
            v-if="!isGenerating && !generatedVideo"
            id="app-menu-content"
            class="page-wrap"
          >
            <!-- Header -->
            <div class="page-header">
           

              <div class="header-title">
                <div class="title">تولید ویدیو با هوش مصنوعی</div>
              </div>

              <button class="header-icon-btn" type="button" @click="showHistory" aria-label="history">
                <i class="fa-solid fa-clock-rotate-left"></i>
              </button>
            </div>

            <!-- Main content grid (desktop) -->
            <div class="content-grid">

              <!-- LEFT / TOP: Prompt + Attach -->
              <div class="left-col">

                <!-- Prompt Hero Card -->
                <div class="card hero-card">
                  <div class="card-head">
                    <div class="card-title">
                      <i class="fa-solid fa-lightbulb"></i>
                      توضیح ویدیو
                    </div>

                    <div class="card-actions">
                      <button class="chip" type="button" @click="randomPrompt()">
                        <i class="fa-solid fa-wand-magic-sparkles"></i>
                        ایده بده
                      </button>
                      <button class="icon-btn" type="button" @click="prompt = ''" aria-label="clear">
                        <i class="fa-solid fa-trash"></i>
                      </button>
                    </div>
                  </div>

                  <textarea
                    id="textarea-input"
                    v-model="prompt"
                    class="prompt-input"
                    autocomplete="off"
                    type="text"
                    autofocus=""
                    @keydown.enter="handleEnter"
                    placeholder="ویدیویی که می‌خوای بسازی رو اینجا توصیف کن… هرچی دقیق‌تر باشه نتیجه بهتره."
                  />

                  <div class="hint">
                    <i class="fa-solid fa-circle-info"></i>
                    متن انگلیسی معمولاً نتیجه بهتر می‌دهد.
                  </div>
                </div>

                <!-- Image Attach (Optional) - minimal inline -->
                <div class="card">
                  <div class="card-head">
                    <div class="card-title">
                      <i class="fa-regular fa-image"></i>
                      تصویر (اختیاری)
                    </div>

                    <button
                      v-if="selectedImagePreview"
                      class="icon-btn danger"
                      type="button"
                      @click.stop="clearSelectedImage"
                      aria-label="remove image"
                      title="حذف تصویر"
                    >
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </div>

                  <div
  class="attach-row"
  :class="{ drag: isImageDragOver, has: !!selectedImagePreview }"
  role="button"
  tabindex="0"
  @click="openImagePicker"
  @keydown.enter.prevent="openImagePicker"
  @keydown.space.prevent="openImagePicker"
  @dragenter.prevent="onImageDragEnter"
  @dragover.prevent="onImageDragOver"
  @dragleave.prevent="onImageDragLeave"
  @drop.prevent="onImageDrop"
>
  <input
    ref="imageInput"
    type="file"
    accept="image/png,image/jpeg,image/webp"
    class="hidden-file-input"
    @change="onImagePicked"
  />

  <div class="attach-left">
    <!-- ✅ NEW: thumbnail when selected -->
    <div v-if="selectedImagePreview" class="attach-thumb">
      <img :src="selectedImagePreview" alt="preview" />
    </div>

    <!-- empty icon when NOT selected -->
    <div v-else class="attach-icon">
      <i class="fa-solid fa-cloud-arrow-up"></i>
    </div>

    <div class="attach-meta">
      <div class="attach-title">
        {{ selectedImagePreview ? selectedImageName : 'افزودن تصویر' }}
      </div>
      <div class="attach-sub">
        {{ selectedImagePreview ? selectedImageSizeLabel : 'تا 5 مگابایت PNG / JPG / WEBP' }}
      </div>
    </div>
  </div>

  <div class="attach-right">
    <button
      v-if="selectedImagePreview"
      class="ghost-btn"
      type="button"
      @click.stop="openImagePicker"
    >
      <i class="fa-solid fa-rotate"></i>
      تغییر
    </button>

    <i v-else class="fa-solid fa-chevron-left chev"></i>
  </div>
</div>


                  <div class="hint">
                    <i class="fa-solid fa-circle-info"></i>
                    افزودن تصویر باعث می‌شود ویدیو با همان استایل/سوژه تولید شود.
                  </div>
                </div>
              </div>

              <!-- RIGHT / BOTTOM: Settings -->
              <div class="right-col">

                <!-- Collapsible Settings -->
                <div class="card">
                  <button class="collapse-head" type="button" @click="showSettings = !showSettings">
                    <div class="collapse-title">
                      <i class="fa-solid fa-sliders"></i>
                      تنظیمات
                    </div>
                    <i class="fa-solid" :class="showSettings ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                  </button>

                  <div v-if="showSettings" class="collapse-body">

                    <!-- Duration -->
                    <div class="setting-block">
                      <div class="setting-title">
                        <i class="fa-solid fa-clock"></i>
                        مدت زمان
                      </div>
                      <div class="segmented">
                        <button
                          v-for="option in durationOptions"
                          :key="option.value"
                          type="button"
                          class="seg-btn"
                          :class="{ active: selectedDuration === option.value }"
                          @click="selectedDuration = option.value"
                        >
                          {{ option.text }}
                        </button>
                      </div>
                    </div>

                    <!-- Resolution -->
                    <div class="setting-block">
                      <div class="setting-title">
                        <i class="fa-solid fa-expand"></i>
                        نسبت تصویر
                      </div>
                      <div class="segmented">
                        <button
                          v-for="option in resolutionOptions"
                          :key="option.value"
                          type="button"
                          class="seg-btn"
                          :class="{ active: selectedResolution === option.value }"
                          @click="selectedResolution = option.value"
                        >
                          {{ option.text }}
                        </button>
                      </div>
                    </div>

                    <!-- Model -->
                    <div class="setting-block">
                      <div class="setting-title">
                        <i class="fa-solid fa-robot"></i>
                        مدل
                      </div>
                      <div class="segmented">
                        <button
                          v-for="option in modelOptions"
                          :key="option.value"
                          type="button"
                          class="seg-btn"
                          :class="{ active: selectedModel === option.value }"
                          @click="selectedModel = option.value"
                        >
                          {{ option.text }}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

                <!-- Desktop-only helper -->
                <br/>
                <br/>
              </div>
            </div>

            <!-- Spacer so content doesn't hide under sticky bar (mobile) -->
            <div class="sticky-spacer"></div>
          </div>

          <!-- =========================
               GENERATING
               ========================= -->
          <div
            v-if="isGenerating"
            class="generating-full"
          >
            <div class="generating-container">
              <div class="video-animation">
                <div class="video-frame">
                  <i class="fa-solid fa-video video-icon"></i>
                </div>
                <div class="loading-dots">
                  <span></span><span></span><span></span>
                </div>
              </div>

              <div class="generating-text">
                <h2 class="gen-title">در حال خلق ویدیوی شما…</h2>
                <p class="gen-sub">این فرآیند ممکن است چند دقیقه طول بکشد.</p>
              </div>

              <div class="progress-container">
                <div class="progress-bar">
                  <div class="progress-fill" :style="{ width: progress + '%' }"></div>
                </div>
                <span class="progress-text">{{ Math.round(progress) }}%</span>
              </div>
            </div>
          </div>

          <!-- =========================
               RESULT
               ========================= -->
          <div v-if="generatedVideo && !isGenerating" class="result-container">
            <div class="success-header" style="margin-top:20px">
              <i class="fa-solid fa-check-circle success-icon"></i>
              <h2 class="result-title">ویدیو با موفقیت تولید شد!</h2>
            </div>

            <div class="video-result">
              <div class="video-preview">
                <video
                  :src="generatedVideo.url"
                  controls
                  class="generated-video"
                  poster="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjNjE1M2NjIi8+CjxwYXRoIGQ9Ik0xNzUgMTUwTDI1MCAyMDBMMTc1IDI1MFYxNTBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                ></video>
              </div>

              <div class="video-info">
                <div class="info-item">
                  <span class="info-label">مدل:</span>
                  <span class="info-value">{{ getModelName(selectedModel) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">مدت زمان:</span>
                  <span class="info-value">{{ getDurationText(selectedDuration) }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">رزولوشن:</span>
                  <span class="info-value">{{ getResolutionText(selectedResolution) }}</span>
                </div>
              </div>

              <div class="action-buttons">
                <a
                  v-if="!isApplication"
                  :href="generatedVideo.url"
                  download
                  rel="noopener noreferrer"
                  target="_blank"
                  class="action-link"
                >
                  <i class="fa-solid fa-download"></i>
                  دانلود
                </a>

                <v-btn
                  v-else
                  @click="downloadVideo"
                  color="#6153cc"
                  size="large"
                  class="action-btn"
                  style="font-family: IRANSansWeb; margin-left: 10px;"
                >
                  <template v-slot:prepend>
                    <i class="fa-solid fa-download"></i>
                  </template>
                  دانلود
                </v-btn>
              </div>

              <div class="new-video-section">
                <v-btn
                  @click="createNewVideo"
                  variant="outlined"
                  color="#6153cc"
                  size="large"
                  class="new-video-btn"
                  style="font-family: IRANSansWeb;"
                >
                  <template v-slot:prepend>
                    <i class="fa-solid fa-plus"></i>
                  </template>
                  ساخت ویدیوی جدید
                </v-btn>
                <br/>
                <br/>
                <br/>
                <br/>

              </div>
            </div>
          </div>

          <!-- Paywall -->
          <PaywallABTest
            :isVisible="isModalKharid"
            :userCredit="credit"
            :totalCookies="5"
            triggerSource="Video"
            @close="isModalKharid = false"
            @activate="handlePaywallActivate"
          />

          <!-- History Modal -->
          <div v-if="isModalHistory" class="history-modal">
            <div class="history-modal-content">
              <div class="history-header">
                <h3 class="history-title">
                  <i class="fa-solid fa-history"></i>
                  تاریخچه ویدیوها
                </h3>
                <i @click="isModalHistory = false" class="fa-solid fa-x close-icon"></i>
              </div>

              <div class="history-list" v-if="!isLoadingHistory">
                <div v-if="videoHistory.length === 0" class="empty-history">
                  <i class="fa-solid fa-video-slash empty-ico"></i>
                  <p class="empty-txt">هنوز ویدیویی تولید نکرده‌اید</p>
                </div>

                <div
                  v-else
                  v-for="video in videoHistory"
                  :key="video.id"
                  class="history-item"
                  @click="previewHistoryVideo(video)"
                >
                  <div class="history-item-thumbnail">
                    <video :src="video.url" class="history-thumbnail-video"></video>
                    <div class="play-overlay">
                      <i class="fa-solid fa-play"></i>
                    </div>
                  </div>

                  <div class="history-item-info">
                    <div class="history-item-prompt">
                      {{ video.prompt.substring(0, 60) }}{{ video.prompt.length > 60 ? '...' : '' }}
                    </div>
                    <div class="history-item-details">
                      <span class="history-detail">{{ getDurationText(video.duration) }}</span>
                      <span class="history-detail">{{ getResolutionText(video.resolution) }}</span>
                      <span class="history-detail">{{ getModelName(video.model) }}</span>
                    </div>
                    <div class="history-item-date">{{ formatDate(video.created_at) }}</div>
                  </div>
                </div>
              </div>

              <div v-else class="history-loading">
                <div class="loading-spinner"></div>
                <p class="loading-txt">در حال بارگذاری...</p>
              </div>
            </div>
          </div>

          <!-- History Preview Modal -->
          <div v-if="isModalHistoryPreview" class="history-preview-modal">
            <div class="history-preview-content">
              <div class="history-preview-header">
                <h3 class="history-title">
                  <i class="fa-solid fa-eye"></i>
                  پیش‌نمایش ویدیو
                </h3>
                <i @click="isModalHistoryPreview = false" class="fa-solid fa-x close-icon"></i>
              </div>

              <div class="history-preview-body">
                <div class="preview-video-container">
                  <video
                    :src="selectedHistoryVideo.url"
                    controls
                    class="preview-video"
                    poster="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgdmlld0JveD0iMCAwIDQwMCAzMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiBmaWxsPSIjNjE1M2NjIi8+CjxwYXRoIGQ9Ik0xNzUgMTUwTDI1MCAyMDBMMTc1IDI1MFYxNTBaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"
                  ></video>
                </div>

                <div class="preview-info">
                  <div class="preview-section">
                    <label class="preview-label">توضیح ویدیو:</label>
                    <div class="preview-prompt">{{ selectedHistoryVideo.prompt }}</div>
                  </div>

                  <div class="preview-section">
                    <label class="preview-label">تنظیمات:</label>
                    <div class="preview-settings">
                      <div class="preview-setting-item">
                        <span class="setting-name">مدل:</span>
                        <span class="setting-value">{{ getModelName(selectedHistoryVideo.model) }}</span>
                      </div>
                      <div class="preview-setting-item">
                        <span class="setting-name">مدت زمان:</span>
                        <span class="setting-value">{{ getDurationText(selectedHistoryVideo.duration) }}</span>
                      </div>
                      <div class="preview-setting-item">
                        <span class="setting-name">رزولوشن:</span>
                        <span class="setting-value">{{ getResolutionText(selectedHistoryVideo.resolution) }}</span>
                      </div>
                    </div>
                  </div>

                  <div class="preview-section">
                    <label class="preview-label">تاریخ تولید:</label>
                    <div class="preview-date">{{ formatDate(selectedHistoryVideo.created_at) }}</div>
                  </div>
                </div>

                <div class="preview-actions">
                  <v-btn
                    @click="downloadHistoryVideo"
                    color="#6153cc"
                    size="large"
                    class="preview-action-btn"
                    style="font-family: IRANSansWeb; margin-left: 10px;"
                  >
                    <template v-slot:prepend>
                      <i class="fa-solid fa-download"></i>
                    </template>
                    دانلود
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <!-- =========================
               STICKY GENERATE BAR (only in create view)
               ========================= -->
               <div
  v-if="!isGenerating && !generatedVideo"
  class="sticky-generate"
>
  <div class="sticky-inner">
    <div class="sticky-left">
      <div class="sticky-chips">
        <span class="s-chip">
          <i class="fa-solid fa-clock"></i>
          {{ getDurationText(selectedDuration) }}
        </span>
        <span class="s-chip">
          <i class="fa-solid fa-expand"></i>
          {{ getResolutionText(selectedResolution) }}
        </span>
        <span class="s-chip cost">
          {{ selectedDuration * 10 }}🍪
        </span>
      </div>

      
    </div>

    <button
      class="sticky-btn"
      :disabled="!prompt.trim() || isGenerating"
      @click="generateVideo"
      type="button"
    >
      <i class="fa-solid fa-magic"></i>
      تولید
    </button>
  </div>
</div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import router from '@/router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
import PaywallABTest from '@/components/PaywallABTest.vue';

export default {
  name: 'VideoGenerationView',
  components: { PaywallABTest },
  data() {
    return {
      prompt: '',
      negativePrompt: '',
      selectedDuration: 4,
      selectedResolution: '9:16',
      selectedModel: 0,
      isGenerating: false,
      isModalKharid: false,
      isModalHistory: false,
      isModalHistoryPreview: false,
      generatedVideo: null,
      progress: 0,
      videoHistory: [],
      selectedHistoryVideo: null,
      isLoadingHistory: false,
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,

      showSettings: true, // mobile-first collapsible

      durationOptions: [
        { text: '2 ثانیه', value: 2 },
        { text: '4 ثانیه', value: 4 },
        { text: '6 ثانیه', value: 6 },
        { text: '8 ثانیه', value: 8 },
        { text: '10 ثانیه', value: 10 },
      ],
      resolutionOptions: [
        { text: '۱۶:۹ (افقی)', value: '16:9' },
        { text: '۹:۱۶ (عمودی)', value: '9:16' },
        { text: '۱:۱ (مربعی)', value: '1:1' }
      ],
      modelOptions: [
        { text: 'روبو', value: 0 },
      ],

      // Image
      selectedImageFile: null,
      selectedImagePreview: null,
      selectedImageName: '',
      selectedImageSizeLabel: '',
      selectedImageBase64: null,
      isImageDragOver: false,
    }
  },

  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.checkMobile);
    if (this.selectedImagePreview) {
      try { URL.revokeObjectURL(this.selectedImagePreview); } catch {}
    }
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
      // On desktop, keep settings open
      if (!this.isMobile) this.showSettings = true;
    },

    handlePaywallActivate(data) {
      this.isModalKharid = false;
      if (data && data.package && data.period) {
        router.push({ path: '/packages', query: { package: data.package, period: data.period } });
      } else {
        router.push('/packages');
      }
    },

    showHistory() {
      this.isModalHistory = true;
      this.loadVideoHistory();
    },

    async loadVideoHistory() {
      this.isLoadingHistory = true;
      try {
        const response = await axios.post("https://api.roboo.ir/api/video/GetCreatedUserVideo", {
          token: localStorage.getItem("token")
        });
        this.videoHistory = response.data;
      } catch (error) {
        console.error('Error loading video history:', error);
        this.videoHistory = [];
      } finally {
        this.isLoadingHistory = false;
      }
    },

    previewHistoryVideo(video) {
      this.selectedHistoryVideo = video;
      this.isModalHistory = false;
      this.isModalHistoryPreview = true;
    },

    downloadHistoryVideo() {
      if (this.selectedHistoryVideo?.url) {
        if (this.isApplication) {
          Android.Download(this.selectedHistoryVideo.url);
        } else {
          const link = document.createElement('a');
          link.href = this.selectedHistoryVideo.url;
          link.download = `history_video_${Date.now()}.mp4`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    formatDate(dateString) {
      if (!dateString) return 'نامشخص';
      const date = new Date(dateString);
      return date.toLocaleDateString('fa-IR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    handleEnter(e) {
      if (e.ctrlKey || e.metaKey) {
        this.generateVideo();
      }
    },

    randomPrompt() {
      const prompts = [
        "صحنه کامل، زاویه دید چشم، نمای باز، یک ربات غول‌پیکر در خیابان، با کیفیت بالا، جزئیات زیاد",
        "یک موجود بامزه با پوست شبیه پلنگ برفی در جنگل زمستانی راه می‌رود، رندر به سبک کارتونی سه‌بعدی.",
        "سبک فیلم نوآر، مرد و زن در خیابان راه می‌روند، رمزآلود، سینمایی، سیاه و سفید.",
        "یک کورگی شاد با عینک آفتابی روی یک وسیله بادی نارنجی روشن در اقیانوس آبی درخشان شناور است.",
      ];
      this.prompt = prompts[Math.floor(Math.random() * prompts.length)];
    },

    // ---------------- Image picker ----------------
    openImagePicker() {
      this.$refs.imageInput?.click();
    },

    onImagePicked(e) {
      const file = e?.target?.files?.[0];
      if (!file) return;
      this.handleSelectedImageFile(file);
      e.target.value = '';
    },

    onImageDragEnter() { this.isImageDragOver = true; },
    onImageDragOver() { this.isImageDragOver = true; },
    onImageDragLeave() { this.isImageDragOver = false; },

    onImageDrop(e) {
      this.isImageDragOver = false;
      const file = e?.dataTransfer?.files?.[0];
      if (!file) return;
      this.handleSelectedImageFile(file);
    },

    async handleSelectedImageFile(file) {
      const allowed = ['image/jpeg', 'image/png', 'image/webp'];
      if (!allowed.includes(file.type)) {
        notify({ title: "خطا", text: "فرمت تصویر باید PNG یا JPG یا WEBP باشد.", type: "error" });
        return;
      }

      const maxBytes = 5 * 1024 * 1024;
      if (file.size > maxBytes) {
        notify({ title: "خطا", text: "حجم تصویر نباید بیشتر از ۵ مگابایت باشد.", type: "error" });
        return;
      }

      this.selectedImageFile = file;
      this.selectedImageName = file.name || 'image';
      this.selectedImageSizeLabel = this.humanFileSize(file.size);

      const objectUrl = URL.createObjectURL(file);
      if (this.selectedImagePreview) {
        try { URL.revokeObjectURL(this.selectedImagePreview); } catch {}
      }
      this.selectedImagePreview = objectUrl;

      this.selectedImageBase64 = await this.fileToBase64(file);
    },

    clearSelectedImage() {
      if (this.selectedImagePreview) {
        try { URL.revokeObjectURL(this.selectedImagePreview); } catch {}
      }
      this.selectedImageFile = null;
      this.selectedImagePreview = null;
      this.selectedImageName = '';
      this.selectedImageSizeLabel = '';
      this.selectedImageBase64 = null;
    },

    humanFileSize(bytes) {
      if (!bytes && bytes !== 0) return '';
      const thresh = 1024;
      if (bytes < thresh) return bytes + ' B';
      const units = ['KB', 'MB', 'GB'];
      let u = -1;
      do { bytes /= thresh; ++u; } while (bytes >= thresh && u < units.length - 1);
      return bytes.toFixed(1) + ' ' + units[u];
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    // ---------------- Generate ----------------
    async generateVideo() {
      if (!this.prompt.trim()) return;

      let isFarsi = false;
      let char = new RegExp("[\u0600-\u06FF]");
      if (char.test(this.prompt) === true) isFarsi = true;

      let json = {
        token: localStorage.getItem("token"),
        prompt: this.prompt,
        farsi: isFarsi,
        duration: this.selectedDuration,
        resolution: this.selectedResolution,
        model: this.selectedModel,
        initImage: this.selectedImageBase64
      }

      this.isGenerating = true;
      this.progress = 0;

      const progressInterval = setInterval(() => {
        if (this.progress < 90) this.progress += Math.random() * 10;
      }, 3000);

      axios.post("https://api.roboo.ir/api/video/generatevideo", json).then(response => {
        if (response.data.status == 0) {
          this.isGenerating = false;
          this.generatedVideo = { url: response.data.message, id: 'video_' + Date.now(), timestamp: new Date().toISOString() };

          if (localStorage.getItem("onBoardingAction") == "") {
            setTimeout(() => { this.$emit("showOnboardingPopup", 3); }, 3000)
          }

          clearInterval(progressInterval);
          this.progress = 100;

          this.userInfo.credit = this.userInfo.credit - this.selectedDuration * 10;
          this.$emit("setCredit");
        }
        else if (response.data.status == 2) {
          this.isGenerating = false;
          clearInterval(progressInterval);
          this.istyping = false;
          this.isModalKharid = true;
          return;
        }
        else {
          this.isGenerating = false;
          clearInterval(progressInterval);
          notify({ title: "خطا", text: response.data.message, type: "error" });
          return;
        }
      }).catch(() => {
        this.isGenerating = false;
        clearInterval(progressInterval);
        notify({ title: "خطا", text: "هنگام ارسال درخواست مشکلی پیش آمد \nوضعیت اینترنت خود را بررسی کنید", type: "error" });
        return;
      });
    },

    getModelName(modelValue) {
      const model = this.modelOptions.find(m => m.value === modelValue);
      return model ? model.text : 'نامشخص';
    },
    getDurationText(duration) {
      const durationOption = this.durationOptions.find(d => d.value === duration);
      return durationOption ? durationOption.text : 'نامشخص';
    },
    getResolutionText(resolution) {
      const resolutionOption = this.resolutionOptions.find(r => r.value === resolution);
      return resolutionOption ? resolutionOption.text : 'نامشخص';
    },

    downloadVideo() {
      if (this.generatedVideo?.url) Android.Download(this.generatedVideo?.url);
    },

    createNewVideo() {
      this.prompt = '';
      this.negativePrompt = '';
      this.selectedDuration = 4;
      this.selectedResolution = '9:16';
      this.selectedModel = 0;
      this.generatedVideo = null;
      this.progress = 0;
      this.clearSelectedImage();
      if (this.isMobile) this.showSettings = true;
    }
  }
}
</script>

<style scoped>
/* =========================
   Base
   ========================= */
.video-page {
  min-height: 100vh;
  color: white;
}

.page-wrap{
  padding: 16px;
  margin: 0 auto;
  max-width: 1050px;
}

/* Desktop padding */
@media (min-width: 900px){
  .page-wrap{
    padding: 28px 22px;
  }
}

/* =========================
   Header
   ========================= */
.page-header{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap: 12px;
  padding: 12px 12px;
  border-radius: 16px;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  direction: rtl;
  margin-bottom: 16px;
  margin-top: 50px;
}

.header-title{
  text-align:right;
  flex: 1;
  min-width: 0;
}
.header-title .title{
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 16px;
  line-height: 1.3;
}
.header-title .subtitle{
  font-family: IRANSansWeb;
  font-size: 12px;
  color: rgba(255,255,255,0.6);
  margin-top: 2px;
}

.header-icon-btn{
  width: 42px;
  height: 42px;
  border-radius: 14px;
  background: rgba(97,83,204,0.18);
  border: 1px solid rgba(97,83,204,0.22);
  color: #fff;
  cursor: pointer;
  transition: all .2s ease;
}
.header-icon-btn:hover{
  transform: translateY(-1px);
  background: rgba(97,83,204,0.26);
  border-color: rgba(97,83,204,0.35);
}

/* =========================
   Layout grid (desktop)
   ========================= */
.content-grid{
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

@media (min-width: 900px){
  .content-grid{
    grid-template-columns: 1.2fr 0.8fr;
    gap: 18px;
    align-items: start;
  }
}

.left-col, .right-col{
  display:flex;
  flex-direction: column;
  gap: 14px;
}

.desktop-only{ display:none; }
@media (min-width: 900px){
  .desktop-only{ display:block; }
}

/* =========================
   Card system
   ========================= */
.card{
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 18px;
  padding: 14px;

  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden; /* ✅ last safety net */
}

.hero-card{
  padding: 16px;
}

.card-head{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;
  direction: rtl;
  margin-bottom: 10px;
}

.card-title{
  display:flex;
  align-items:center;
  gap: 8px;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 14px;
}

.card-title i{
  opacity: .95;
}

.card-actions{
  display:flex;
  align-items:center;
  gap: 10px;
}

.icon-btn{
  width: 36px;
  height: 36px;
  border-radius: 12px;
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.06);
  color: #fff;
  cursor:pointer;
  transition: all .2s ease;
}
.icon-btn:hover{
  transform: translateY(-1px);
  background: rgba(255,255,255,0.09);
  border-color: rgba(97,83,204,0.35);
}
.icon-btn.danger:hover{
  background: rgba(253,118,145,0.18);
  border-color: rgba(253,118,145,0.35);
}

.chip{
  border: 1px solid rgba(97,83,204,0.30);
  background: rgba(97,83,204,0.18);
  color:#fff;
  padding: 8px 12px;
  border-radius: 999px;
  font-family: IRANSansWeb;
  font-weight: 800;
  font-size: 12px;
  cursor:pointer;
  display:flex;
  align-items:center;
  gap: 8px;
  transition: all .2s ease;
}
.chip:hover{
  transform: translateY(-1px);
  background: rgba(97,83,204,0.26);
  border-color: rgba(97,83,204,0.45);
}

/* =========================
   Prompt
   ========================= */
.prompt-input{
  width: 100%;
  min-height: 130px;
  resize: none;
  border: 1px solid rgba(255,255,255,0.10);
  background: rgba(0,0,0,0.10);
  outline: none;
  border-radius: 16px;
  padding: 14px;
  font-family: IRANSansWeb;
  font-size: 15px;
  color: white;
  line-height: 1.9;
  direction: rtl;
  transition: all .2s ease;
}
.prompt-input:focus{
  border-color: rgba(97,83,204,0.7);
  box-shadow: 0 0 0 3px rgba(97,83,204,0.20);
}

.hint{
  margin-top: 10px;
  display:flex;
  gap: 8px;
  direction: rtl;
  font-family: IRANSansWeb;
  font-size: 12px;
  color: rgba(255,255,255,0.62);
  line-height: 1.6;
}
.hint i{ margin-top: 2px; opacity: .9; }

/* =========================
   Attach row (FIXED: no overflow + clean preview)
   ========================= */
   .hidden-file-input{ display:none; }

.attach-row{
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;

  padding:14px;
  border-radius:14px;

  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.10);

  overflow: hidden;              /* ✅ prevents expansion */
  min-width: 0;                  /* ✅ allow children to shrink */
  cursor: pointer;

  transition: background .2s ease, border-color .2s ease, transform .2s ease;
}
.attach-row * { min-width: 0; }
.attach-row:hover{
  border-color: rgba(97,83,204,0.40);
  background: rgba(0,0,0,0.14);
  transform: translateY(-1px);
}

.attach-row.drag{
  border-color: rgba(97,83,204,0.85);
  box-shadow: 0 0 0 3px rgba(97,83,204,0.20);
}

/* Left side (thumb/icon + text) */
.attach-left{
  flex: 1 1 0%;          /* ✅ key fix: don’t size by content */
  min-width: 0;
  max-width: 100%;

  display:flex;
  align-items:center;
  gap:12px;

  overflow: hidden;
}


/* Thumbnail (when selected) */
.attach-thumb{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.14);
  box-shadow: 0 10px 22px rgba(0,0,0,0.25);
  flex: 0 0 auto;
}
.attach-thumb img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display:block;
}

/* Icon (when empty) */
.attach-icon{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  background: rgba(97,83,204,0.16);
  border: 1px solid rgba(97,83,204,0.22);
  display:flex;
  align-items:center;
  justify-content:center;
  flex: 0 0 auto;
}
.attach-icon i{ color:#fff; }

/* Meta text */
.attach-meta{
  flex: 1 1 0%;          /* ✅ key fix: must shrink */
  width: 0;              /* ✅ extra hard lock for Safari/Android WebView */
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

/* Filename can be long; force ellipsis safely */
.attach-title{
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 13px;
  color: #fff;

  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  direction: ltr;                /* ✅ filenames look correct */
  unicode-bidi: plaintext;
  text-align: right;
}

/* Size line */
.attach-sub{
  font-family: IRANSansWeb;
  font-size: 12px;
  color: rgba(255,255,255,0.6);

  max-width: 100%;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  direction: ltr;
  unicode-bidi: plaintext;
  text-align: right;
}

/* Right side (button/chev) */
.attach-right{
  flex: 0 0 auto;
  flex-shrink: 0;
  max-width: 120px;
}

/* Change button should NEVER cause layout growth */
.ghost-btn{
  flex: 0 0 auto;
  flex-shrink: 0;
  white-space: nowrap;

  border:none;
  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.10);
  color:#fff;
  padding: 8px 10px;
  border-radius: 12px;
  cursor:pointer;

  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 12px;

  display:flex;
  align-items:center;
  gap:6px;

  max-width: 96px;               /* ✅ hard cap on mobile */
  overflow: hidden;
}

.ghost-btn:hover{
  transform: translateY(-1px);
  background: rgba(97,83,204,0.18);
  border-color: rgba(97,83,204,0.35);
}

.chev{
  color: rgba(255,255,255,0.40);
}


/* =========================
   Collapsible settings
   ========================= */
.collapse-head{
  width: 100%;
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 4px;
  background: transparent;
  border: none;
  color: #fff;
  cursor: pointer;
  direction: rtl;
}
.collapse-title{
  display:flex;
  align-items:center;
  gap: 8px;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 14px;
}
.collapse-body{
  margin-top: 12px;
  display:flex;
  flex-direction: column;
  gap: 14px;
}

.setting-block{
  direction: rtl;
}
.setting-title{
  display:flex;
  align-items:center;
  gap: 8px;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 13px;
  margin-bottom: 10px;
  color: rgba(255,255,255,0.92);
}

.segmented{
  display:flex;
  flex-wrap: wrap;
  gap: 10px;
}

.seg-btn{
  border: 1px solid rgba(255,255,255,0.12);
  background: rgba(255,255,255,0.05);
  color: rgba(255,255,255,0.90);
  border-radius: 14px;
  padding: 10px 12px;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 12px;
  cursor:pointer;
  transition: all .2s ease;
}
.seg-btn:hover{
  transform: translateY(-1px);
  border-color: rgba(97,83,204,0.35);
  background: rgba(97,83,204,0.12);
}
.seg-btn.active{
  background: rgba(97,83,204,0.30);
  border-color: rgba(97,83,204,0.45);
  box-shadow: 0 8px 18px rgba(97,83,204,0.20);
}

/* A small desktop helper */
.soft-note{
  margin-top: 6px;
  padding: 10px 12px;
  border-radius: 14px;
  background: rgba(255,255,255,0.04);
  border: 1px dashed rgba(255,255,255,0.12);
  direction: rtl;
  font-family: IRANSansWeb;
  font-size: 12px;
  color: rgba(255,255,255,0.65);
  display:flex;
  align-items:center;
  gap: 8px;
}

/* =========================
   Sticky generate bar
   ========================= */
   .sticky-spacer{ height: 96px; }

/* floating container */
.sticky-generate{
  position: fixed;
  left: 0;
  right: 0;
  bottom: 72px; /* above bottom nav */
  padding: 10px 14px;
  z-index: 999;
  pointer-events: none;
}

.sticky-inner{
  max-width: 1050px;
  margin: 0 auto;
  pointer-events: auto;

  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 12px;

  padding: 10px 10px;
  border-radius: 18px;

  background: rgba(18,18,18,0.65);
  border: 1px solid rgba(255,255,255,0.10);
  backdrop-filter: blur(10px);

  box-shadow: 0 18px 40px rgba(0,0,0,0.35);
}

.sticky-left{
  display:flex;
  flex-direction: column;
  gap: 6px;
  direction: rtl;
  min-width: 0;
}

.sticky-chips{
  display:flex;
  gap: 8px;
  flex-wrap: wrap;
}

.s-chip{
  display:flex;
  align-items:center;
  gap: 6px;

  padding: 7px 10px;
  border-radius: 999px;

  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 12px;

  background: rgba(255,255,255,0.06);
  border: 1px solid rgba(255,255,255,0.10);
  color: rgba(255,255,255,0.90);
}

.s-chip.cost{
  background: rgba(97,83,204,0.18);
  border-color: rgba(97,83,204,0.25);
  color: #fff;
}

.sticky-hint{
  font-family: IRANSansWeb;
  font-size: 11px;
  color: rgba(255,255,255,0.55);
  display:flex;
  align-items:center;
  gap: 6px;
}

.sticky-btn{
  border: none;
  border-radius: 16px;
  padding: 12px 16px;

  background: linear-gradient(135deg, #6153cc 0%, #8b5cf6 100%);
  color: #fff;

  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 14px;

  cursor: pointer;
  display:flex;
  align-items:center;
  gap: 10px;

  box-shadow: 0 12px 26px rgba(97,83,204,0.35);
  transition: transform .2s ease, box-shadow .2s ease, opacity .2s ease;
  white-space: nowrap;
}
.sticky-btn:hover{
  transform: translateY(-1px);
  box-shadow: 0 16px 34px rgba(97,83,204,0.45);
}
.sticky-btn:disabled{
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* small screens */
@media (max-width: 420px){
  .sticky-hint{ display:none; } /* keep minimal */
}


/* =========================
   Generating / Result (kept close to yours)
   ========================= */
.generating-full{
  height: 100vh;
  display:flex;
  justify-content:center;
  align-items:center;
}
.generating-container{ text-align:center; padding: 40px 20px; }
.video-animation{ margin-bottom: 34px; }
.video-frame{
  width: 110px; height: 74px;
  background: linear-gradient(135deg, #6153cc 0%, #fd7691 100%);
  border-radius: 16px;
  display:flex; align-items:center; justify-content:center;
  margin: 0 auto 18px;
  animation: pulse 2s infinite;
}
.video-icon{ font-size: 28px; color:#fff; animation: bounce 1.5s infinite; }

.loading-dots{
  display:flex; justify-content:center; gap: 8px;
}
.loading-dots span{
  width: 10px; height: 10px;
  background:#fff; border-radius: 50%;
  animation: dots 1.4s infinite ease-in-out;
}
.loading-dots span:nth-child(1){ animation-delay: -0.32s; }
.loading-dots span:nth-child(2){ animation-delay: -0.16s; }

.gen-title{
  font-size: 20px;
  font-weight: 900;
  font-family: IRANSansWeb;
  margin: 0 0 10px 0;
}
.gen-sub{
  font-size: 13px;
  font-family: IRANSansWeb;
  color: rgba(255,255,255,0.75);
  margin: 0;
}

.progress-container{ margin-top: 24px; width:100%; max-width: 420px; }
.progress-bar{
  width:100%; height: 8px;
  background: rgba(255,255,255,0.18);
  border-radius: 999px;
  overflow:hidden;
  margin-bottom: 10px;
}
.progress-fill{
  height: 100%;
  background: linear-gradient(90deg, #6153cc 0%, #fd7691 100%);
  border-radius: 999px;
  transition: width .3s ease;
}
.progress-text{ font-size: 13px; font-family: IRANSansWeb; color:#fff; }

.result-container{
  margin-top: 22px;
  padding: 22px 16px;
  text-align:center;
}
.success-icon{ font-size: 56px; color:#4CAF50; }
.result-title{
  font-size: 20px;
  font-weight: 900;
  font-family: IRANSansWeb;
  margin: 12px 0 12px 0;
}
.video-result{ max-width: 720px; margin: 0 auto; }
.generated-video{
  width: 100%;
  max-width: 560px;
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.35);
}

.video-info{
  background: rgba(97,83,204,0.10);
  border-radius: 16px;
  padding: 16px;
  margin: 18px auto 18px;
  border: 1px solid rgba(97,83,204,0.22);
  max-width: 560px;
}
.info-item{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  direction: rtl;
}
.info-item:last-child{ border-bottom:none; }
.info-label{ font-weight: 900; font-family: IRANSansWeb; }
.info-value{ font-family: IRANSansWeb; }

.action-buttons{
  display:flex;
  justify-content:center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.action-link{
  display:flex;
  align-items:center;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 14px;
  background: rgba(97,83,204,0.95);
  color: #fff;
  font-family: IRANSansWeb;
  font-weight: 900;
  text-decoration: none;
}
.action-link:hover{ opacity: .95; transform: translateY(-1px); transition: .2s; }

/* =========================
   Modals (kept mostly)
   ========================= */
.history-modal,
.history-preview-modal{
  position: fixed;
  top:0; left:0;
  width:100%; height:100%;
  background: rgba(0,0,0,0.82);
  z-index: 10000;
  display:flex;
  align-items:center;
  justify-content:center;
  padding: 16px;
}

.history-modal-content,
.history-preview-content{
  background: rgb(24,24,24);
  border-radius: 16px;
  width: 100%;
  max-width: 820px;
  max-height: 85vh;
  overflow: hidden;
  box-shadow: 0 15px 25px rgba(0,0,0,0.6);
  border: 1px solid rgba(255,255,255,0.08);
}

.history-header,
.history-preview-header{
  display:flex;
  justify-content: space-between;
  align-items:center;
  padding: 16px;
  border-bottom: 1px solid rgba(255,255,255,0.08);
  direction: rtl;
}
.history-title{
  margin:0;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 16px;
  color:#fff;
  display:flex;
  align-items:center;
  gap: 8px;
}
.close-icon{
  font-size: 18px;
  color: rgba(255,255,255,0.85);
  cursor:pointer;
}
.close-icon:hover{ color:#fff; }

.history-list{
  padding: 16px;
  max-height: 65vh;
  overflow-y: auto;
}

.empty-history{ text-align:center; padding: 30px 16px; }
.empty-ico{ font-size: 44px; opacity: .9; }
.empty-txt{ font-family: IRANSansWeb; color:#fff; margin-top: 12px; }

.history-item{
  display:flex;
  gap: 12px;
  background: rgba(255,255,255,0.05);
  border-radius: 14px;
  padding: 12px;
  margin-bottom: 12px;
  cursor:pointer;
  border: 1px solid rgba(255,255,255,0.08);
  transition: all .2s ease;
  direction: rtl;
}
.history-item:hover{
  transform: translateY(-1px);
  border-color: rgba(97,83,204,0.35);
  background: rgba(255,255,255,0.08);
}
.history-item-thumbnail{
  width: 120px;
  height: 80px;
  border-radius: 12px;
  overflow:hidden;
  position: relative;
  flex-shrink:0;
}
.history-thumbnail-video{ width:100%; height:100%; object-fit: cover; }
.play-overlay{
  position:absolute; inset:0;
  background: rgba(0,0,0,0.45);
  display:flex;
  align-items:center;
  justify-content:center;
}
.play-overlay i{ color:#fff; }

.history-item-info{ flex:1; min-width:0; }
.history-item-prompt{
  font-family: IRANSansWeb;
  font-size: 13px;
  line-height: 1.6;
  margin-bottom: 8px;
}
.history-item-details{
  display:flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}
.history-detail{
  background: rgba(97,83,204,0.22);
  border: 1px solid rgba(97,83,204,0.25);
  color:#fff;
  padding: 4px 8px;
  border-radius: 999px;
  font-family: IRANSansWeb;
  font-size: 11px;
  font-weight: 900;
}
.history-item-date{
  font-family: IRANSansWeb;
  font-size: 11px;
  color: rgba(255,255,255,0.55);
}

.history-loading{
  text-align:center;
  padding: 30px 16px;
}
.loading-spinner{
  width: 38px; height: 38px;
  border: 4px solid rgba(255,255,255,0.10);
  border-top: 4px solid #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}
.loading-txt{
  font-family: IRANSansWeb;
  color:#fff;
  margin-top: 12px;
}

.history-preview-body{
  padding: 16px;
  max-height: 72vh;
  overflow-y: auto;
}
.preview-video{ width:100%; max-width: 560px; border-radius: 16px; box-shadow: 0 10px 30px rgba(0,0,0,0.35); }
.preview-video-container{ text-align:center; margin-bottom: 18px; }

.preview-label{
  display:block;
  font-family: IRANSansWeb;
  font-weight: 900;
  font-size: 13px;
  margin-bottom: 8px;
  direction: rtl;
}
.preview-prompt{
  background: rgba(97,83,204,0.10);
  border: 1px solid rgba(97,83,204,0.22);
  border-radius: 14px;
  padding: 12px;
  font-family: IRANSansWeb;
  line-height: 1.8;
  direction: rtl;
}
.preview-settings{
  display:grid;
  grid-template-columns: 1fr;
  gap: 10px;
}
.preview-setting-item{
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 14px;
  padding: 10px 12px;
  display:flex;
  justify-content: space-between;
  align-items:center;
  direction: rtl;
}
.setting-name{ font-family: IRANSansWeb; font-weight: 900; font-size: 12px; }
.setting-value{ font-family: IRANSansWeb; font-size: 12px; opacity: .95; }
.preview-date{ font-family: IRANSansWeb; color: rgba(255,255,255,0.75); direction: rtl; }

.preview-actions{
  display:flex;
  justify-content:center;
  margin-top: 16px;
}

/* =========================
   Animations
   ========================= */
@keyframes pulse { 0%,100%{ transform: scale(1);} 50%{ transform: scale(1.05);} }
@keyframes bounce { 0%,20%,50%,80%,100%{ transform: translateY(0);} 40%{ transform: translateY(-10px);} 60%{ transform: translateY(-5px);} }
@keyframes dots { 0%,80%,100%{ transform: scale(0);} 40%{ transform: scale(1);} }
@keyframes spin { 0%{ transform: rotate(0deg);} 100%{ transform: rotate(360deg);} }

/* =========================
   Scrollbar
   ========================= */
::-webkit-scrollbar { width: 8px; }
::-webkit-scrollbar-track { background: rgba(255,255,255,0.08); border-radius: 4px; }
::-webkit-scrollbar-thumb { background: rgba(97,83,204,0.85); border-radius: 4px; }
::-webkit-scrollbar-thumb:hover { background: #ffffff; }

/* Mobile tweak: make sticky bar sit above bottom nav comfortably */
@media (max-width: 768px){
  .sticky-generate{ bottom: 72px; }
}

.attach-thumb{
  width: 44px;
  height: 44px;
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid rgba(255,255,255,0.14);
  box-shadow: 0 10px 22px rgba(0,0,0,0.25);
  flex-shrink: 0;
}
.attach-thumb img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  display:block;
}

</style>
